import { createSelector } from "@reduxjs/toolkit";
import { ZViewSnapshotMongoDocument } from "@multiconsult-group/multiplacer-core";
import type { GetMultiplacerViewsByViewIdApiResponse } from "../../../openapi";

export const selectSharedViewDocument = createSelector(
  [(response: GetMultiplacerViewsByViewIdApiResponse | undefined) => response],
  response => response?.kind === "snapshot" ? ZViewSnapshotMongoDocument.required({ _id: true }).parse(response) : undefined,
);
